// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ContactApiClient extends BaseCRUDApiClient<ContactDto> {
  baseUrl = this.config.apiEndpoint + '/contact';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
